import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useMemo, useState } from 'react';
import { useEthers } from './useEthers';
import { useReadonlyNetworks } from '../providers/network/readonlyNetworks';
import { useBlockNumbers, useBlockNumber } from '../hooks';
/**
 * Returns all blockchain logs given a block filter.
 * The hook will cause the component to refresh when a new block is mined and the returned logs change.
 * @see {@link useLogs} for a more easy-to-use version of the query.
 * @param filter an event filter, which blocks to query
 * @param queryParams allows for additional configuration of the query (see {@link QueryParams})
 * @returns an array of [logs](https://docs.ethers.io/v5/api/providers/types/#providers-Log)
 * @public
 */
export function useRawLogs(filter) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _useEthers = useEthers(),
    library = _useEthers.library;
  var providers = useReadonlyNetworks();
  var _blockNumber = useBlockNumber();
  var blockNumbers = useBlockNumbers();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    logs = _useState2[0],
    setLogs = _useState2[1];
  var chainId = queryParams.chainId;
  var _useMemo = useMemo(function () {
      return chainId ? [providers[chainId], blockNumbers[chainId]] : [library, _blockNumber];
    }, [providers, library, blockNumbers, _blockNumber, chainId]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    provider = _useMemo2[0],
    blockNumber = _useMemo2[1];
  function updateLogs() {
    return _updateLogs.apply(this, arguments);
  }
  function _updateLogs() {
    _updateLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = setLogs;
            if (filter) {
              _context.next = 5;
              break;
            }
            _context.t1 = undefined;
            _context.next = 8;
            break;
          case 5:
            _context.next = 7;
            return provider === null || provider === void 0 ? void 0 : provider.getLogs(filter);
          case 7:
            _context.t1 = _context.sent;
          case 8:
            _context.t2 = _context.t1;
            (0, _context.t0)(_context.t2);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateLogs.apply(this, arguments);
  }
  useEffect(function () {
    void updateLogs();
  }, [provider, blockNumber]);
  return logs;
}